import { getDetailTaskItemData } from './getDetailTaskItemData'
import dayjs, { Dayjs } from 'dayjs'
import { IDataByDay, IDataByDayItem } from '../selectors'
import { getSlotByTime } from './getSlotByTime'
import { TimeTableSlots } from '../consts/timeTableSlots'

const keys = Object.keys(TimeTableSlots)

export const getDetailTimeSlotData = (value: Dayjs, dataByDay: IDataByDay, time: string) => {
  const result: IDataByDayItem[] = []

  getDetailTaskItemData(value, dataByDay)?.forEach(itemData => {
    const h = dayjs(itemData.deadline).subtract(1, 'minute').format('H')
    const slot = getSlotByTime(keys, h)
    if (slot === time) {
      result.push(itemData)
    }
  })

  return result
}
